import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import type { ICartStore as ICommonCartStore } from "@repo/shopifyV2/interface/cart";
import { initCart } from "@repo/shopifyV2/stores/cart";
import { mergeCart } from "@repo/shopifyV2/stores/persist";

/** 공용 카트 스토어에 카트 동기화 상태만 더한다 (isSyncing 은 persist 하지 않는다) */
export interface ICartStore extends ICommonCartStore {
  /** 로그인 직후 카트 복원/병합 진행 중 여부 */
  isSyncing: boolean;
  setSyncing: (isSyncing: boolean) => void;
}

const localLang = localStorage.getItem("i18nextLng") || "ko";

export const useCartStore = create<ICartStore>()(
  persist(
    (set) => ({
      // 초기값
      ...initCart,
      isSyncing: false,

      // 함수
      updateCart: (cart) => {
        set(() => ({ cart }));
      },
      setSyncing: (isSyncing: boolean) => {
        set(() => ({ isSyncing }));
      },
    }),
    {
      name: `${localLang}-cart`,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ cart: { id: state.cart.id } }),
      merge: mergeCart,
    },
  ),
);
